module.exports = __webpack_public_path__ + "assets/img/gar5-6.40d26598.jpg";